// removed by extract-text-webpack-plugin
module.exports = {"exploremore":"exploremore__12V73"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Navbar/NavbarCurrency.scss
// module id = 1110
// module chunks = 68